module.exports = __webpack_public_path__ + "img/icon-group1.d71a44b1.png";